import * as React from "react";
const SvgMinusSymbol = (props) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 12.5V11.5H18V12.5H6Z", fill: "currentColor" }));
export default SvgMinusSymbol;
